/**
 * bootprompt.js locale configuration
 * locale : Finnish
 * author : Nick Payne
 */

import { addLocale } from "../bootprompt";

addLocale("fi", {
  OK: "OK",
  CANCEL: "Peruuta",
  CONFIRM: "OK",
});
